import { SCREEN_WIDTH } from 'constants/ui';

export const loanInfoCardsWrapperBaseStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: 'repeat(4, 1fr)',
  },
  gap: '8px',
  flex: 1,
};

export const loanInfoCardsWrapperStyles = {
  ...loanInfoCardsWrapperBaseStyles,

  [`@media (min-width: ${SCREEN_WIDTH.M}px) and (max-width: ${SCREEN_WIDTH.L - 1}px)`]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
};

export const hoverContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const hoverTitleStyles = {
  fontSize: '16px',
  fontWeight: '700',
};

export const hoverDescriptionListStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '8px',

  '& > div': {
    minWidth: '117.5px',
  },
};
